module.exports = __webpack_public_path__ + "themes/fq/img/star.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/star.png
// module id = 66
// module chunks = d-game